import { useRef } from 'react'

import { Tabs, TabsList, TabsTrigger } from '../tabs'

interface FormRadioGroupTabProps {
  items: {
    label: string
    value: string
  }[]
  value: string
  onValueChange: (value: string) => void
}

export function FormRadioGroupTab(props: FormRadioGroupTabProps) {
  const { items, value, onValueChange } = props
  const ref = useRef<HTMLDivElement>(null)

  return (
    <Tabs defaultValue={value} onValueChange={onValueChange} className="w-full">
      <TabsList className="w-full bg-[#F2F4F8] [&>*]:flex-1" ref={ref}>
        {items.map((item) => (
          <TabsTrigger key={item.value} value={item.value}>
            {item.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
